<app-page-container>
  <header class="header">
    <h1 class="header__title">Inventário</h1>
    <p class="header__text">Patrimônio:
      <span class="header__text header__text--bold">
        {{data?.numPat}} |
      </span> Nº de
      Série:
      <span class="header__text header__text--bold">
        {{data?.numserie}}
      </span>
    </p>
    <app-botao-voltar></app-botao-voltar>
  </header>

  <section class="section">
    <article class="section__first-column">
      <h2 class="section__title">Sobre o equipamento</h2>
      <div class="section__card">
        <p class="section__card__text section__card__text--bold">
          Nº de Série:
          <span class="section__card__text">
            {{data?.numserie}}
          </span>
        </p>
        <p class="section__card__text section__card__text--bold">
          Marca:
          <span class="section__card__text">
            {{data?.marca}}
          </span>
        </p>
        <p class="section__card__text section__card__text--bold">
          Modelo:
          <span class="section__card__text">
            {{data?.modelo}}
          </span>
        </p>
        <p class="section__card__text section__card__text--bold">
          Contrato:
          <span class="section__card__text">
            {{data?.nomeContrato}}
          </span>
        </p>
      </div>
      <h2 class="section__title">Histórico de posse</h2>
      <div>
        <div class="section__history" *ngFor="let item of data?.historicosPosse">
          <div class="section__history__decorator-column">
            <area class="section__history__decorator-column__dot" />
            <area class="section__history__decorator-column__bar" />
          </div>
          <div class="section__history__content">
            <p class="section__history__text">{{item.dataMovimentacao | date: "dd/MM/yyyy"}} | Em posse de</p>
            <p class="section__history__text section__history__text--bold">{{item.nomeContatoPosse}}
              ({{item.siteDatabit}})</p>
          </div>
        </div>
      </div>
      <button class="section__add-activity-button" (click)="showAddActivityModal()">Adicionar atividade</button>
    </article>
    <!-- *ngIf="autorizacoes.alterarPosseInventario"  -->
    <article class="section__second-column">
      <form class="section__form" [formGroup]="formGroup">
        <label class="section__form__label" for="centroCustoID">
          Centro de custo
          <select class="section__form__select" required name="centroCustoID" formControlName="centroCustoID">
            <option value="">Selecione</option>
            <option value="9">9</option>
          </select>
        </label>
        <label class="section__form__label" for="siteDatabit">
          Site/Filial
          <select class="section__form__select" required name="siteDatabit" formControlName="siteDatabit">
            <option value="">Selecione</option>
            <option *ngFor="let state of states" value="{{state.nome}}">{{state.nome}}</option>
          </select>
        </label>
        <label class="section__form__label" for="nomeContatoPosse">
          Nome do contato*
          <input class="section__form__input" required placeholder="Digite aqui..." type="text" name="nomeContatoPosse"
            formControlName="nomeContatoPosse">
        </label>
        <label class="section__form__label" for="celularContatoPosse">
          Celular*
          <input class="section__form__input" required placeholder="Digite aqui..." type="text"
            name="celularContatoPosse" formControlName="celularContatoPosse" mask="(00) 00000-0000">
        </label>
        <label class="section__form__label" for="telefoneContatoPosse">
          Telefone
          <input class="section__form__input" required placeholder="Digite aqui..." type="text"
            name="telefoneContatoPosse" formControlName="telefoneContatoPosse" mask="(00) 0000-0000">
        </label>
        <label class="section__form__label" for="emailContatoPosse">
          Email
          <input class="section__form__input" required placeholder="Digite aqui..." type="text" name="emailContatoPosse"
            formControlName="emailContatoPosse">
        </label>
        <!-- [disabled]="formGroup.invalid"  -->
        <input class="section__form__submit" type="submit" value="Alterar" (click)="onFormSubmit()">
      </form>
    </article>
  </section>
</app-page-container>
<app-modal-general #modalSucesso [titulo]="'Editar'" [botao]="'Fechar'" [mensagem]="'Informações editadas com sucesso!'"
  (cliqueBotao)="fecharModal()"></app-modal-general>